import React, { useContext, useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import StoreContext from '../../Store/context';
import AccessRestricted from '../../Error/AccessRestricted/AccessRestricted';
import {
  isAdminUser,
  isManagerOrAbove,
  hasAccessCode,
} from '../../../utils/permissionUtils';

const RoutesPrivate = ({
  component: Component,
  children,
  adminOnly = false,
  managerOnly = false,
  requiredAccess = null,
  ...rest
}) => {
  const { credencials, setCredencials } = useContext(StoreContext);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const hasLoginToken = Boolean(params.get('loginToken'));

  useEffect(() => {
    if (hasLoginToken) {
      setCredencials(null);
    }
  }, [hasLoginToken, setCredencials]);

  useEffect(() => {
    if (credencials && location.pathname !== '/home' && location.pathname !== '/') {
      const recentPages = JSON.parse(localStorage.getItem('recentPages') || '[]');
      const currentPage = {
        path: location.pathname,
        name: location.pathname.split('/').slice(2).map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' '),
        timestamp: new Date().getTime()
      };

      // Remove duplicates and keep only last 8
      const updatedPages = [
        currentPage,
        ...recentPages.filter(p => p.path !== currentPage.path)
      ].slice(0, 8);

      localStorage.setItem('recentPages', JSON.stringify(updatedPages));

    }
  }, [location, credencials]);

  if (hasLoginToken) {
    return <Redirect to={`/${location.search}`} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!credencials) {
          return <Redirect to="/" />;
        }

        if (adminOnly && !isAdminUser(credencials)) {
          return <AccessRestricted requiredLevel="Administrador" />;
        }

        if (managerOnly && !isManagerOrAbove(credencials)) {
          return <AccessRestricted requiredLevel="Gerente" />;
        }

        if (requiredAccess && !hasAccessCode(credencials, requiredAccess)) {
          return <AccessRestricted requiredLevel="Permissão Específica" />;
        }

        if (Component) {
          return <Component {...props} />;
        }
        return children;
      }}
    />
  );
};

export default RoutesPrivate;


